"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../../themes/base");
var SubMenuLayer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  z-index: 999;\n  overflow: hidden;\n  max-width: initial;\n  transition: height ", "ms ease-in-out;\n  position: absolute;\n  top: 100%;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  background-color: ", ";\n  z-index: 999;\n  overflow: hidden;\n  max-width: initial;\n  transition: height ", "ms ease-in-out;\n  position: absolute;\n  top: 100%;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), base_1.base.global.colors['white'], base_1.base.global.transition.durationMS, function (_a) {
    var left = _a.left, currentSize = _a.currentSize;
    return "left: " + (currentSize === 'xs' ? 0 : left) + "px;";
}, function (_a) {
    var right = _a.right;
    return "right: " + right + "px;";
}, function (_a) {
    var height = _a.height;
    return "height: " + height + "px;";
}, function (_a) {
    var width = _a.width, currentSize = _a.currentSize;
    return "width: " + (currentSize === 'xs' ? '100%' : width + "px") + ";";
});
exports.default = SubMenuLayer;
var templateObject_1;
//# sourceMappingURL=SubMenuLayer.js.map